import React, { useEffect } from "react";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import { orange } from "@material-ui/core/colors";
import "./ClientThanks.css";
const ColorButton = withStyles((theme) => ({
  root: {
    color: "white",
    backgroundColor: "#C34720",
    "&:hover": {
      backgroundColor: orange[900],
    },
  },
}))(Button);

function ClientThanks(props: any) {
  return (
    <div className="Thanks">
      <div></div>
      <div className="success-checkmark">
        <div className="check-icon">
          <span className="icon-line line-tip"></span>
          <span className="icon-line line-long"></span>
          <div className="icon-circle"></div>
          <div className="icon-fix"></div>
        </div>
      </div>
      <div className="Thanks-desk small-text center"> 
        Twoje zamówienie jest w trakcie realizacji, wkrótce skontaktujemy się z Tobą w celu wyjaśnienia szczegółów
      </div>
     
      <div>
        <ColorButton onClick={() => {props.handleClose();   setTimeout(function(){ props.handeSend(false)},500);}} className="button-fullwidth">Ok</ColorButton>
      </div>
    </div>
  );
}

export default ClientThanks;
